export default __webpack_public_path__ + "static/media/Levitate D3.4 Methods for cost-benefit analysis to support decision making.d7a0d29c.pdf";